import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { VendedorService } from "src/app/services/vendedor.service";
import { SecurityService } from "src/app/shared/services/security.service";
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { ConsoleService } from "src/app/shared/services/console.service";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { DatesService } from "src/app/shared/services/dates.service";
import { FileDownloadService } from "src/app/shared/services/file-download.service";
import * as _ from 'lodash'
import { RutService } from "src/app/shared/services/rut.service";
import { FamiliaService } from "src/app/services/familia.service";
import { RubroService } from "src/app/services/rubro.service";
import { PaginationContext } from "src/app/shared/object/pagination_context.model";

@Component({
  selector: 'app-vendedores-familia',
  templateUrl: './vendedores-familia.component.html',
  styleUrls: ['./vendedores-familia.component.scss'],
  providers: [SecurityService],
})
export class VendedoresFamiliaComponent implements OnInit {
  // Constants
  readonly RB_TIPO_VISTA_DOCUMENTO: String = "_RB_TIPO_VISTA_DOCUMENTO_"
  readonly RB_TIPO_VISTA_FAMILIA: String = "_RB_TIPO_VISTA_FAMILIA_"
  readonly RB_TIPO_VISTA_PRODUCTO: String = "_RB_TIPO_VISTA_PRODUCTO_"

  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number

  private documento_currentPayload: any = null
  documento_loading: boolean = false
  documento_listaMovimientos: Array<any> = null
  documento_listaMovimientosAll: Array<any> = null
  documento_paginationContext: PaginationContext = new PaginationContext()
  documento_totales: any = null

  private familia_currentPayload: any = null
  familia_loading: boolean = false
  familia_listaMovimientos: Array<any> = null
  familia_listaMovimientosAll: Array<any> = null
  familia_paginationContext: PaginationContext = new PaginationContext()
  familia_totales: any = null

  private producto_currentPayload: any = null
  producto_loading: boolean = false
  producto_listaMovimientos: Array<any> = null
  producto_listaMovimientosAll: Array<any> = null
  producto_paginationContext: PaginationContext = new PaginationContext()
  producto_totales: any = null

  optionsVendedor: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsFamilia: Array<any> = [];
  optionsFiltroPor: Array<any> = [];

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private vendedorService: VendedorService,
    private rubroService: RubroService,
    private rutService: RutService,
    private familiaService: FamiliaService,
  ) {
    this.log = this.clog.log('REP. VTAS. VENDEDOR FAMILIA')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.documento_paginationContext.RecordsByPage = 10
    this.familia_paginationContext.RecordsByPage = 10
    this.producto_paginationContext.RecordsByPage = 10
    this.loadVendedores()
    this.loadFamilias()
    this.createForm()
    this.loadNiveles()

  }
  loadNiveles() {
    this.optionsFiltroPor = [
      { value: this.RB_TIPO_VISTA_DOCUMENTO, label: "Documento" },
      { value: this.RB_TIPO_VISTA_FAMILIA, label: "Familia" },
      { value: this.RB_TIPO_VISTA_PRODUCTO, label: "Producto" },
    ];
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('tipoVista'), this.optionsFiltroPor)
  }

  private loadFamilias() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
      }
    }
    this.familiaService.obtenerFamiliasSolas(inputParams, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsFamilia = registros.map(familia => ({ value: familia.codigo, label: familia.nombre, ...familia }))
    })
  }

  loadVendedores() {
    this.vendedorService.obtenerActivos(this.rutEmpresa, this.sucursalCodigo, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta
      this.optionsVendedor = registros.map(vendedor => ({ value: vendedor.codigo, label: vendedor.nombre, ...vendedor }))
    })
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      tipoVista: [[this.RB_TIPO_VISTA_FAMILIA], [Validators.required]],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      vendedores: [[]],
      rubros: [[]],
      familias: [[]],
      producto_sin_sku: [true]
    });
  }
  /********* BÚSQUEDA DOCUMENTO/FAMILIA/PRODUCTO *********/
  buscar(pageNumber: number) {
    this.documentoBuscar(pageNumber)
    this.familiaBuscar(pageNumber)
    this.productoBuscar(pageNumber)
  }
  /********* BÚSQUEDA DOCUMENTOfamilia*/

  documentoBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.documento_paginationContext.CurrentPage = pageNumber

    this.documento_listaMovimientos = null
    this.documento_listaMovimientosAll = null

    const { fechaDesde, fechaHasta, vendedores, rubros, familias, producto_sin_sku } = this.formHeader.value
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaVendedor: vendedores,
        listaRubro: rubros,
        listaFamilia: familias,
        producto_sin_sku
      },
      paginaActual: this.documento_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.resumen_paginationContext.RecordsByPage
    }
    this.documento_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.documento_loading = true
    this.vendedorService.obtenerReporteVendedoresFamiliaDocumento(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta
      this.documento_listaMovimientosAll = registros
      this.documento_paginationContext.RecordsCount = this.documento_listaMovimientosAll.length //totalRegistros
      this.documento_paginationContext.PagesCount = Math.ceil(this.documento_paginationContext.RecordsCount / this.documento_paginationContext.RecordsByPage) //totalPaginas
      this.documento_paginationContext.CurrentPage = 1
      this.documento_listaMovimientosAll.forEach((mov, index) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
      })
      this.showPageDocumento(this.documento_paginationContext.CurrentPage)
      this.calculateTotalesDocumento()
      this.documento_loading = false
    })
  }

  showPageDocumento(pageNumber: number) {
    this.documento_paginationContext.CurrentPage = pageNumber
    const start = (this.documento_paginationContext.CurrentPage - 1) * this.documento_paginationContext.RecordsByPage
    this.documento_listaMovimientos = _.slice(this.documento_listaMovimientosAll, start, start + this.documento_paginationContext.RecordsByPage)
  }

  calculateTotalesDocumento() {
    this.documento_totales = {
      documento: this.documento_listaMovimientosAll.length,
      cantidad: _.sumBy(this.documento_listaMovimientosAll, 'cantidad'),
      monto_neto: _.sumBy(this.documento_listaMovimientosAll, 'monto_neto'),
      descuento: _.sumBy(this.documento_listaMovimientosAll, 'descuento'),
      neto_total: _.sumBy(this.documento_listaMovimientosAll, 'neto_total')
    }
  }

  documentoOnPageChange(context: PaginationContext) {
    // this.resumenBuscar(context.RequestedPage)
    this.showPageDocumento(context.RequestedPage)
  }

  documentoDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.documento_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.vendedorService.obtenerReporteVendedoresFamiliaDocumentoExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  /********* BÚSQUEDA FAMILIA *********/

  familiaBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.familia_paginationContext.CurrentPage = pageNumber
    this.familia_listaMovimientosAll = null

    const { fechaDesde, fechaHasta, vendedores, rubros, familias, producto_sin_sku } = this.formHeader.value
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaVendedor: vendedores,
        listaRubro: rubros,
        listaFamilia: familias,
        producto_sin_sku
      },
      paginaActual: this.familia_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.resumen_paginationContext.RecordsByPage
    }
    this.familia_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.familia_loading = true
    this.vendedorService.obtenerReporteVendedoresFamiliaFamilia(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta
      this.familia_listaMovimientosAll = registros
      this.familia_paginationContext.RecordsCount = this.familia_listaMovimientosAll.length //totalRegistros
      this.familia_paginationContext.PagesCount = Math.ceil(this.familia_paginationContext.RecordsCount / this.familia_paginationContext.RecordsByPage) //totalPaginas
      this.familia_paginationContext.CurrentPage = 1
      this.familia_listaMovimientosAll.forEach((mov, index) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
      })
      this.showPageFamilia(this.familia_paginationContext.CurrentPage)
      this.calculateTotalesFamilia()
      this.familia_loading = false
    })
  }

  showPageFamilia(pageNumber: number) {
    this.familia_paginationContext.CurrentPage = pageNumber
    const start = (this.familia_paginationContext.CurrentPage - 1) * this.familia_paginationContext.RecordsByPage
    this.familia_listaMovimientos = _.slice(this.familia_listaMovimientosAll, start, start + this.familia_paginationContext.RecordsByPage)
  }

  calculateTotalesFamilia() {
    this.familia_totales = {
      documento: this.familia_listaMovimientosAll.length,
      cantidad: _.sumBy(this.familia_listaMovimientosAll, 'cantidad'),
      monto_neto: _.sumBy(this.familia_listaMovimientosAll, 'monto_neto'),
      descuento: _.sumBy(this.familia_listaMovimientosAll, 'descuento'),
      neto_total: _.sumBy(this.familia_listaMovimientosAll, 'neto_total')
    }
  }

  familiaOnPageChange(context: PaginationContext) {
    // this.resumenBuscar(context.RequestedPage)
    this.showPageFamilia(context.RequestedPage)
  }

  familiaDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.familia_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.vendedorService.obtenerReporteVendedoresFamiliaFamiliaExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  /********* BÚSQUEDA PRODUCTO *********/

  productoBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.producto_paginationContext.CurrentPage = pageNumber

    this.producto_listaMovimientos = null
    this.producto_listaMovimientosAll = null

    const { fechaDesde, fechaHasta, vendedores, rubros, familias, producto_sin_sku } = this.formHeader.value
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        listaVendedor: vendedores,
        listaRubro: rubros,
        listaFamilia: familias,
        producto_sin_sku
      },
      paginaActual: this.producto_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.resumen_paginationContext.RecordsByPage
    }
    this.producto_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.producto_loading = true
    this.vendedorService.obtenerReporteVendedoresFamiliaProducto(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros } = respuesta
      this.producto_listaMovimientosAll = registros
      this.producto_paginationContext.RecordsCount = this.producto_listaMovimientosAll.length //totalRegistros
      this.producto_paginationContext.PagesCount = Math.ceil(this.producto_paginationContext.RecordsCount / this.producto_paginationContext.RecordsByPage) //totalPaginas
      this.producto_paginationContext.CurrentPage = 1
      this.producto_listaMovimientosAll.forEach((mov, index) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
      })
      this.showPageProducto(this.producto_paginationContext.CurrentPage)
      this.calculateTotalesProducto()
      this.producto_loading = false
    })
  }

  showPageProducto(pageNumber: number) {
    this.producto_paginationContext.CurrentPage = pageNumber
    const start = (this.producto_paginationContext.CurrentPage - 1) * this.producto_paginationContext.RecordsByPage
    this.producto_listaMovimientos = _.slice(this.producto_listaMovimientosAll, start, start + this.producto_paginationContext.RecordsByPage)
  }

  calculateTotalesProducto() {
    this.producto_totales = {
      documento: this.producto_listaMovimientosAll.length,
      cantidad: _.sumBy(this.producto_listaMovimientosAll, 'cantidad'),
      monto_neto: _.sumBy(this.producto_listaMovimientosAll, 'monto_neto'),
      descuento: _.sumBy(this.producto_listaMovimientosAll, 'descuento'),
      neto_total: _.sumBy(this.producto_listaMovimientosAll, 'neto_total')
    }
  }

  productoOnPageChange(context: PaginationContext) {
    // this.resumenBuscar(context.RequestedPage)
    this.showPageProducto(context.RequestedPage)
  }

  productoDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.producto_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.vendedorService.obtenerReporteVendedoresFamiliaProductoExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

}

